import type { Board } from "../board";
import { getMobGoldValue } from "../economy/mobGoldValues";
import type { Direction } from "../direction";
import { directionDelta } from "../direction";
import type { PointsToDirection } from "../interfaces";
import { ParticleType } from "../particleType";
import type { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import { WeakMob } from "../weakMob";
import type { XY } from "../xy";
import { AmoebaCorpse } from "./amoebaCorpse";

export class ArrowMob extends WeakMob implements PointsToDirection {
	static key = "ArrowMob";
	private direction: Direction;

	constructor(xy: XY, direction: Direction) {
		super(xy);
		this.direction = direction;
	}

	override getBloodParticleType(): ParticleType {
		return ParticleType.BLOOD;
	}

	override getBaseGoldValue(): number {
		return getMobGoldValue(ArrowMob.key);
	}

	getDirection(): Direction | null {
		return this.direction;
	}

	setDirection(dir: Direction): void {
		this.direction = dir;
	}

	processMobAction(_board: Board): void {
		const delta = directionDelta(this.direction);
		const target = this.xy.add(delta);
		if (this.canMoveTo(target)) {
			this.moveTo(target);
		}
	}

	createSolidifiedVariant(): PhysicalThing | null {
		return null;
	}

	generateCorpse(): PhysicalThing | null {
		return new AmoebaCorpse(this.xy);
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), direction: this.direction };
	}

	static deserialize(data: any): ArrowMob {
		const m = new ArrowMob(deserializeXY(data.xy), data.direction);
		m.restoreMobFields(data);
		return m;
	}
}
